import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { foundingMemberCreatorPath, foundingMemberCreatorStagePath } from "@travily/routes";
import type FoundingMemberCreatorFamilySubscribe from "@travily/types/pages/FoundingMemberCreatorFamilySubscribe";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { SubscribeStepView } from "./show.view";

type FormData = {
  family_profile: {
    newsletter_consent: "yes" | "no" | null;
  };
};

const FIELD = "family_profile.newsletter_consent";

const SubscribeStep = ({ stage_index, stage_order, family_profile }: FoundingMemberCreatorFamilySubscribe) => {
  const { form, validate, fieldError, currentStage, totalStages, onBack, onPrimary, primaryPending } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => foundingMemberCreatorStagePath("family", stage),
        entryUrl: foundingMemberCreatorPath(),
      },
      stageName: "subscribe",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: { family_profile: { newsletter_consent: family_profile.newsletter_consent ?? null } },
    });

  const error = fieldError(FIELD);

  const topBarActions = useCreatorTopBarActions();

  return (
    <>
      <Head title={t("web.founding_members.creator.steps.family.subscribe.show.meta_title")}>
        <meta
          name="description"
          content={t("web.founding_members.creator.steps.family.subscribe.show.meta_description")}
        />
      </Head>
      <SubscribeStepView
        currentStage={currentStage}
        totalStages={totalStages}
        primaryPending={primaryPending}
        newsletterConsent={form.data.family_profile.newsletter_consent}
        error={error}
        topBarActions={topBarActions}
        onBack={onBack}
        onPrimary={onPrimary}
        onSelect={(value) => {
          form.setData(FIELD, value);
          validate(FIELD);
        }}
      />
    </>
  );
};

export default SubscribeStep;
